const colors = {
  // Primary Colors (Purple)
  primary: '#7c3aed', // Purple highlight from Hero
  primaryLight: '#8b5cf6',
  primaryDark: '#6d28d9',
  primaryGradient: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)',

  // Secondary Colors (Purple-Pink Gradient for Stats)
  secondary: '#c084fc', // Light purple
  secondaryLight: '#e9d5ff',
  secondaryDark: '#a855f7',
  secondaryGradient: 'linear-gradient(to right, #c084fc, #e9d5ff)',

  // Background colors
  white: '#ffffff',
  black: '#000000',
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray200: '#e5e7eb',

  // Border colors
  borderLight: 'rgba(0, 0, 0, 0.05)',

  // Component backgrounds
  heroBackground: 'linear-gradient(to bottom, white, #f9fafb)',
  statsBackground: 'black',
  featuresBackground: 'white',
  cardBackground: 'linear-gradient(135deg, #f9fafb, #f3f4f6)',

  // Glass Effects
  glassLight: 'rgba(255, 255, 255, 0.25)',
  glassDark: 'rgba(15, 23, 42, 0.2)',
  glassBorder: 'rgba(255, 255, 255, 0.18)',
  statsCard: 'rgba(255, 255, 255, 0.05)',
  glassBlur: 'backdrop-filter: blur(16px)',

  // Text colors
  textPrimary: '#000000', // Black text
  textSecondary: '#6b7280', // Gray text used across components
  textLight: '#ffffff', // White text
  textLightMuted: 'rgba(255, 255, 255, 0.7)', // Used in Stats component

  // Semantic Colors
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3b82f6',

  // Shadows
  shadowSm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  shadowMd:
    '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  shadowLg:
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  shadowXl:
    '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

export default colors;
